<ng-container *transloco="let t">
  @if (loadingState$$().isLoading) {
    <div
      class="backdrop"
      [class.white]="loadingState$$().screenColor === 'white'"
      [class.black]="loadingState$$().screenColor === 'black'"
    >
      <div class="loading-content">
        <ess-loading-spinner [color]="loadingState$$().screenColor" />
        <p class="sans">
          {{ t(loadingState$$().messageKey) }}
          <span>{{ t('itinerary.thisRequestCouldTakeAFewSeconds') }} </span>
        </p>
      </div>
    </div>
  }
</ng-container>
